/**
 * Compliance (plan E05-T05): the rules that apply to the tenant's calls and where they come from, a
 * simulator that explains a decision, and the consent ledger and do-not-call list (owners and
 * admins: compliance:read).
 */
import * as Tabs from "@radix-ui/react-tabs";
import { Page } from "../app/Page";
import { useCan } from "../app/session";
import { useT } from "../i18n";
import { Consents } from "./Consents";
import { DoNotCall } from "./DoNotCall";
import { Rules } from "./Rules";
import { Simulator } from "./Simulator";

const TABS = ["rules", "simulator", "consents", "dnc"] as const;

export function CompliancePage() {
  const t = useT();
  const records = useCan("compliance:read");
  const tabs = TABS.filter((tab) => records || (tab !== "consents" && tab !== "dnc"));
  return (
    <Page title={t("nav.compliance")} description={t("compliance.description")}>
      <Tabs.Root defaultValue="rules" className="space-y-4">
        <Tabs.List aria-label={t("compliance.tabs")} className="flex gap-1 border-b border-[var(--color-border)]">
          {tabs.map((tab) => (
            <Tabs.Trigger key={tab} value={tab}
              className="-mb-px border-b-2 border-transparent px-3 py-2 text-sm data-[state=active]:border-[var(--color-primary)] data-[state=active]:font-semibold">
              {t(`compliance.tab.${tab}`)}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        <Tabs.Content value="rules"><Rules /></Tabs.Content>
        <Tabs.Content value="simulator"><Simulator /></Tabs.Content>
        {records && <Tabs.Content value="consents"><Consents /></Tabs.Content>}
        {records && <Tabs.Content value="dnc"><DoNotCall /></Tabs.Content>}
      </Tabs.Root>
    </Page>
  );
}
